import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const SiteInfoCard = ({ siteData }) => {
  const { t } = useLanguage();

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-2">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-2">{siteData?.site_name}</h2>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={16} />
            <span>{siteData?.address}</span>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
          siteData?.status === 'active' ?'bg-success/10 text-success' :'bg-muted text-muted-foreground'
        }`}>
          {siteData?.status === 'active' ? t('active') : t('inactive')}
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="User" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground font-caption">{t('client')}</span>
          </div>
          <p className="font-medium text-foreground">{siteData?.clientName}</p>
        </div>

        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground font-caption">{t('startDate')}</span>
          </div>
          <p className="font-medium text-foreground">{siteData?.startDate}</p>
        </div>

        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="CalendarCheck" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground font-caption">{t('endDate')}</span>
          </div>
          <p className="font-medium text-foreground">{siteData?.endDate}</p>
        </div>

        <div className="bg-muted rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Users" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground font-caption">{t('workers')}</span>
          </div>
          <p className="font-medium text-foreground">{siteData?.workerCount} {t('assigned')}</p>
        </div>
      </div>
    </div>
  );
};

export default SiteInfoCard;